import { Checkbox } from '@/core/ui/Checkbox';
import { styled } from '@mui/material';
// TODO: mb do refactoring and extract not only styled container, but full component (SelectAllCheckboxButton) (already done)
export const SelectAllCheckboxContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    margin: theme.spacing(2, 0),
    borderRadius: `var(--gp-radius-lg)`,
    ':hover': {
        backgroundColor: theme.palette.background.default,
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.zinc[700],
        }),
    },
}));
// Same as above
export const SelectAllCheckbox = styled(Checkbox)({
    padding: 0,
    marginRight: '.5rem',
    marginLeft: '1px',
});
